<script setup lang="ts">
// The product's mark and name: BLAST Streaming & Encoding Platform (BSEP).
// `full` spells it out (sign-in); otherwise the short name, whole on hover.
// The mark is BLAST's logo in the text colour (public/favicon.svg has it
// white on black, for any tab).
defineProps<{ full?: boolean; sub?: string }>()
</script>

<template>
    <span class="inline-flex items-center gap-2.5" title="BLAST Streaming & Encoding Platform">
        <!-- 2 px above the line's middle: the triangle's weight is low, so centred
             it read as sitting under the text (the boxes measured centred) -->
        <svg viewBox="0 0 26 30" class="h-6 w-5.25 flex-none -translate-y-0.5 text-fg" aria-hidden="true">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.8233 0L10.8688 6.15782L20.2874 13.4723L13.8233 0ZM12.5626 17.1676L18.367 16.6396L17.4623 14.7538L7.86423 7.29977L2.69927 18.0645L9.03341 17.4884L10.875 13.65L12.5626 17.1676ZM14.4962 19.6912L20.3007 19.1633L25.5 30H0L4.51005 20.5996L10.8442 20.0232L8.66156 24.5728H16.8384L14.4962 19.6912Z"
                fill="currentColor"
            />
        </svg>
        <span class="flex flex-col leading-tight">
            <span v-if="full" class="text-sm font-semibold text-fg">BLAST Streaming &amp; Encoding Platform</span>
            <span v-else class="text-[13px] font-bold tracking-[.08em] text-fg">BSEP</span>
            <span v-if="sub" class="text-[11px] text-fg-3">{{ sub }}</span>
        </span>
    </span>
</template>
